import React from 'react';

const Counter = ({ end, label, emoji }) => {
  return (
    <div
      style={{
        flex: '1 1 200px',
        textAlign: 'center',
        background: 'white',
        padding: '30px',
        borderRadius: '15px',
        boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
        fontFamily: 'Roboto',
      }}
    >
      <div
        style={{
          fontSize: '40px',
          marginBottom: '10px',
        }}
      >
        {emoji}
      </div>
      <h2
        style={{
          fontSize: '24px',
          margin: '10px 0',
          color: '#00008B',
        }}
      >
        {end}
      </h2>
      <p
        style={{
          fontSize: '22px',
          margin: 0,
          color: 'black',
        }}
      >
        {label}
      </p>
    </div>
  );
};

const Counts = () => {
  return (
    <section
      id="counts"
      style={{
        padding: '60px 20px',
        background: '#f0f8ff',
        fontFamily: 'Roboto',
        fontSize: '28px',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      {/* Heading styled like Services.js */}
      <div
        style={{
          textAlign: 'center',
          marginBottom: '50px',
        }}
      >
        <div
          style={{
            display: 'inline-block',
            background: '#007bff',
            color: 'white',
            fontWeight: 'bold',
            fontSize: '24px',
            padding: '12px 35px',
            borderRadius: '25px',
            textTransform: 'uppercase',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          }}
        >
          Counts
        </div>
        <p
          style={{
            color: 'blue',
            fontSize: '22px',
            marginTop: '20px',
            fontWeight: 'bold',
            letterSpacing: '1px',
          }}
        >
          Some interesting numbers about us
        </p>
      </div>

      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-around',
          alignItems: 'center',
          gap: '40px',
          fontSize: '18px',
          boxSizing: 'border-box',
        }}
      >
        <Counter end={3} label="Happy Clients" emoji="😊" />
        <Counter end={3} label="Projects" emoji="📓" />
        <Counter end={1463} label="Hours of Support" emoji="🎧" />
        <Counter end={6} label="Hard Workers" emoji="👥" />
      </div>
    </section>
  );
};

export default Counts;
